import { render, staticRenderFns } from "./french_open_class.vue?vue&type=template&id=78f6306f&scoped=true"
import script from "./french_open_class.vue?vue&type=script&lang=js"
export * from "./french_open_class.vue?vue&type=script&lang=js"
import style0 from "./french_open_class.vue?vue&type=style&index=0&id=78f6306f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f6306f",
  null
  
)

export default component.exports